export default {"src":"/_next/static/media/add-task-white.cd1fbac3.svg","height":36,"width":36};